<template>
  <div class="QuestionAdmission">
    <MonthYearComponent
      :id="id"
      :legend="t(`${i18nRoot}_${id}-date-label`)"
      v-model:month="question!.month"
      v-model:year="question!.year"
    />

    <BaseText
      :id="id"
      :label="t(`${i18nRoot}_${id}-reason-label`)"
      :placeholder="t(`${i18nRoot}_${id}-reason-placeholder`)"
      v-model="question!.reason"
      rows="4"
      :max-characters="1024"
      :rules="[required]"
    />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useRules } from '@/modules/core/composables/useRulesComposable'
import BaseText from '@/modules/core/components/ui/BaseText.vue'
import MonthYearComponent from '@/modules/core/components/formFields/MonthYearComponent.vue'
import QuestionAdmission from '@/modules/common/common/models/APP/questionnaire/QuestionAdmission'

const { t } = useI18n()
const { required } = useRules()

const i18nRoot = 'copy_questionnaire-form'

interface PropsInterface {
  id: string
}
withDefaults(defineProps<PropsInterface>(), {})

const question = defineModel<QuestionAdmission>()
</script>
